var _circle, _circle2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_1925:249)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91982 19.2C8.97415 19.1385 9.0398 19.089 9.11282 19.0547C9.18585 19.0203 9.26475 19.0017 9.34482 19H22.6981C22.7546 19.0008 22.8096 19.0187 22.8566 19.0515C22.9037 19.0843 22.9406 19.1306 22.9631 19.1848C22.9856 19.239 22.9926 19.2989 22.9832 19.3572C22.9739 19.4154 22.9488 19.4697 22.9107 19.5133L20.0802 22.8C20.0258 22.8615 19.9602 22.911 19.8872 22.9453C19.8141 22.9797 19.7352 22.9983 19.6552 23H6.29337C6.23687 22.9992 6.1818 22.9813 6.13479 22.9485C6.08778 22.9157 6.05083 22.8694 6.02838 22.8152C6.00594 22.761 5.99895 22.7011 6.00826 22.6428C6.01757 22.5846 6.04278 22.5303 6.08087 22.4867L8.91982 19.2ZM22.9234 16.4755C22.9615 16.5192 22.9867 16.5734 22.9959 16.6317C23.0053 16.69 22.9983 16.7499 22.9759 16.8041C22.9534 16.8583 22.9164 16.9046 22.8694 16.9374C22.8224 16.9702 22.7674 16.9881 22.7108 16.9889L9.35332 17C9.27327 16.9983 9.19434 16.9797 9.12132 16.9453C9.04829 16.911 8.98265 16.8615 8.92833 16.8L6.07662 13.5245C6.03854 13.4808 6.01332 13.4266 6.00401 13.3683C5.9947 13.31 6.00169 13.2502 6.02413 13.1959C6.04658 13.1417 6.08353 13.0954 6.13054 13.0626C6.17755 13.0298 6.23262 13.012 6.28912 13.0111L19.6467 13C19.7267 13.0017 19.8056 13.0203 19.8787 13.0547C19.9517 13.089 20.0173 13.1385 20.0717 13.2L22.9234 16.4755ZM8.91982 7.2C8.97415 7.13847 9.0398 7.08904 9.11282 7.05467C9.18585 7.02031 9.26475 7.00171 9.34482 7L22.7067 7.01111C22.7631 7.01194 22.8182 7.02983 22.8653 7.06261C22.9123 7.0954 22.9492 7.14169 22.9716 7.19592C22.994 7.25015 23.001 7.31 22.9918 7.36828C22.9824 7.42657 22.9572 7.48079 22.9191 7.52445L20.0802 10.8C20.0258 10.8615 19.9602 10.911 19.8872 10.9453C19.8141 10.9797 19.7352 10.9983 19.6552 11H6.29337C6.23687 10.9992 6.1818 10.9813 6.13479 10.9485C6.08778 10.9157 6.05083 10.8694 6.02838 10.8152C6.00594 10.761 5.99895 10.7011 6.00826 10.6428C6.01757 10.5846 6.04278 10.5303 6.08087 10.4867L8.91982 7.2Z",
    fill: "url(#paint1_linear_1925:249)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91982 19.2C8.97415 19.1385 9.0398 19.089 9.11282 19.0547C9.18585 19.0203 9.26475 19.0017 9.34482 19H22.6981C22.7546 19.0008 22.8096 19.0187 22.8566 19.0515C22.9037 19.0843 22.9406 19.1306 22.9631 19.1848C22.9856 19.239 22.9926 19.2989 22.9832 19.3572C22.9739 19.4154 22.9488 19.4697 22.9107 19.5133L20.0802 22.8C20.0258 22.8615 19.9602 22.911 19.8872 22.9453C19.8141 22.9797 19.7352 22.9983 19.6552 23H6.29337C6.23687 22.9992 6.1818 22.9813 6.13479 22.9485C6.08778 22.9157 6.05083 22.8694 6.02838 22.8152C6.00594 22.761 5.99895 22.7011 6.00826 22.6428C6.01757 22.5846 6.04278 22.5303 6.08087 22.4867L8.91982 19.2ZM22.9234 16.4755C22.9615 16.5192 22.9867 16.5734 22.9959 16.6317C23.0053 16.69 22.9983 16.7499 22.9759 16.8041C22.9534 16.8583 22.9164 16.9046 22.8694 16.9374C22.8224 16.9702 22.7674 16.9881 22.7108 16.9889L9.35332 17C9.27327 16.9983 9.19434 16.9797 9.12132 16.9453C9.04829 16.911 8.98265 16.8615 8.92833 16.8L6.07662 13.5245C6.03854 13.4808 6.01332 13.4266 6.00401 13.3683C5.9947 13.31 6.00169 13.2502 6.02413 13.1959C6.04658 13.1417 6.08353 13.0954 6.13054 13.0626C6.17755 13.0298 6.23262 13.012 6.28912 13.0111L19.6467 13C19.7267 13.0017 19.8056 13.0203 19.8787 13.0547C19.9517 13.089 20.0173 13.1385 20.0717 13.2L22.9234 16.4755ZM8.91982 7.2C8.97415 7.13847 9.0398 7.08904 9.11282 7.05467C9.18585 7.02031 9.26475 7.00171 9.34482 7L22.7067 7.01111C22.7631 7.01194 22.8182 7.02983 22.8653 7.06261C22.9123 7.0954 22.9492 7.14169 22.9716 7.19592C22.994 7.25015 23.001 7.31 22.9918 7.36828C22.9824 7.42657 22.9572 7.48079 22.9191 7.52445L20.0802 10.8C20.0258 10.8615 19.9602 10.911 19.8872 10.9453C19.8141 10.9797 19.7352 10.9983 19.6552 11H6.29337C6.23687 10.9992 6.1818 10.9813 6.13479 10.9485C6.08778 10.9157 6.05083 10.8694 6.02838 10.8152C6.00594 10.761 5.99895 10.7011 6.00826 10.6428C6.01757 10.5846 6.04278 10.5303 6.08087 10.4867L8.91982 7.2Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1925:249",
    x1: 0.911449,
    y1: 30.6542,
    x2: 32.0468,
    y2: 2.63281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8A53F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6377D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#24B0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00D18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D18C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1925:249",
    x1: 6.51649,
    y1: 23.3489,
    x2: 23.1976,
    y2: 7.39785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8A53F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6377D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#24B0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00D18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D18C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.90108407.svg";
export { ForwardRef as ReactComponent };